module.exports = __webpack_public_path__ + "img/house-chimney-blank.1a12ea71.svg";